import { Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';

@Component({
  selector: 'app-root',
  imports: [IonApp, IonRouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent {
  title = 'agent';

  /**
   * Ionic's ion-router-outlet runs a stack transition (see app.config navAnimation).
   * While two ion-pages animate, the outgoing page can read as a "ghost" on top of login.
   * Disabling animation only for navigations to /login removes that overlap.
   */
  ionRouterOutletAnimated = true;

  constructor() {
    const router = inject(Router);
    const destroyRef = inject(DestroyRef);
    router.events
      .pipe(
        filter((e): e is NavigationStart => e instanceof NavigationStart),
        takeUntilDestroyed(destroyRef),
      )
      .subscribe((e) => {
        const path = (e.url.split('?')[0] || '').split('#')[0];
        this.ionRouterOutletAnimated = path !== '/login';
      });
  }
}
